import { AllocationViewMode } from './allocation-view.constant';

export type AllocationViewFixedTimelineModel = {
  [key in AllocationViewMode]?: boolean;
};
